<template>
  <div>
    <div class="vx-card p-6">

      <h3>1. Operation</h3>
      <h6 class="mt-8 mb-8" v-if="idinvoiceautoselect && idtransportautoselect"><u>AUTO SELECT</u> INVOICE #{{
        idinvoiceautoselect }} + TRANSPORT #{{ idtransportautoselect }}</h6>
      <div class="vx-row mt-2">
        <div class="vx-col md:w-6/12 w-full">
          <div style="font-size: 85%">Operation Type</div>
          <v-select style="background-color: #ffffff" class="w-full" autocomplete :options="etransport_type"
            v-model="dataETransportType" @input="updateETransportScope()" />
        </div>
        <div class="vx-col md:w-6/12 w-full">
          <div style="font-size: 85%">Operation Scope</div>
          <v-select style="background-color: #ffffff" class="w-full" autocomplete :options="etransport_scope"
            v-model="dataETransportScope" />
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col md:w-6/12 w-full">
          <div style="font-size: 85%">Copy Transport Data</div>
          <v-select autocomplete :options="existingtransport" v-model="dataIdTransportExisting"
            @input="copyTransportData()" />
        </div>
        <div class="vx-col md:w-6/12 w-full">
          <div style="font-size: 85%">Copy Invoice/Purchase Order Data</div>
          <v-select autocomplete :options="existingoperation" v-model="dataIdOperationExisting"
            @input="copyOperationData()" />
        </div>
      </div>
      <div class="vx-row mt-8">
        <div class="vx-col md:w-2/12 w-full">
          <h3>2. Transport</h3>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col md:w-1/3 w-full">
          <p class="w-full mt-2">
          <div style="font-size: 85%">Transport Date</div>
          <datepicker :inline="false" v-model="dataDate"></datepicker>
          </p>
        </div>
      </div>
      <div class="vx-row" v-if="issuesFor('date').length">
        <div class="vx-col w-full">
          <div v-for="(issue, i) in issuesFor('date')" :key="i" class="etx-hint" :class="'etx-' + issue.level">{{ issue.text }}</div>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col w-1/3">
          <div style="font-size: 85%">Country Transporter</div>
          <v-select style="background-color: #ffffff" class="w-full mt-1" autocomplete :options="etransport_country"
            :reduce="country => country.value" v-model="dataETransporterCountry" />
        </div>
        <div class="vx-col w-1/3">
          <vs-input label="Transporter Name" v-model="etransport_transporter_name" class="w-full" />
        </div>
        <div class="vx-col w-1/3">
          <vs-input label="Transporter CIF" v-model="etransport_transporter_cif" class="w-full"
            v-if="dataETransporterCountry === 'RO'" />
        </div>
      </div>
      <div class="vx-row" v-if="issuesFor('transporter').length">
        <div class="vx-col w-full">
          <div v-for="(issue, i) in issuesFor('transporter')" :key="i" class="etx-hint" :class="'etx-' + issue.level">{{ issue.text }}</div>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col w-1/3">
          <vs-input label="Truck plate" v-model="etransport_truckplate" class="w-full" />
        </div>
        <div class="vx-col w-1/3">
          <vs-input label="Trailer plate 1" v-model="etransport_trailerplate1" class="w-full" />
        </div>
        <div class="vx-col w-1/3">
          <vs-input label="Trailer plate 2" v-model="etransport_trailerplate2" class="w-full" />
        </div>
      </div>
      <div class="vx-row" v-if="issuesFor('plates').length">
        <div class="vx-col w-full">
          <div v-for="(issue, i) in issuesFor('plates')" :key="i" class="etx-hint" :class="'etx-' + issue.level">{{ issue.text }}</div>
        </div>
      </div>
      <h3 class="mt-8">3. Route</h3>
      <div class="vx-row mt-2">
        <div class="vx-col w-1/2">
          <div style="font-size: 85%">{{ labelStart }}</div>
          <v-select style="background-color: #ffffff" class="w-full mt-1" autocomplete :options="etransport_start"
            v-model="dataStart" />
        </div>
        <div class="vx-col w-1/2">
          <div style="font-size: 85%">{{ labelStop }}</div>
          <v-select style="background-color: #ffffff" class="w-full mt-1" autocomplete :options="etransport_stop"
            v-model="dataStop" />
        </div>
      </div>
      <div class="vx-row mt-8">
        <div class="vx-col md:w-3/12 w-full">
          <h3>4. Commercial Partner</h3>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col w-1/4">
          <div style="font-size: 85%">Country</div>
          <v-select style="background-color: #ffffff" class="w-full mt-1" autocomplete :options="etransport_country"
            :reduce="country => country.value" v-model="commercialPartner_country" />
        </div>
        <div class="vx-col w-1/4">
          <vs-input label="Partner Name" v-model="commercialPartner_name" class="w-full" />
        </div>
        <div class="vx-col w-1/4">
          <vs-input label="Partner CIF" v-model="commercialPartner_cif" class="w-full"
            v-if="commercialPartner_country === 'RO'" />
        </div>
      </div>
      <div class="vx-row" v-if="issuesFor('partner').length">
        <div class="vx-col w-full">
          <div v-for="(issue, i) in issuesFor('partner')" :key="i" class="etx-hint" :class="'etx-' + issue.level">{{ issue.text }}</div>
        </div>
      </div>
      <h3 class="mt-8">5. Transported Goods</h3>
      <div class="vx-row mt-2">
        <div class="vx-col w-1/12">
          <vs-input label="Cod Tarifar" v-model="currentProduct.codTarifar" class="w-full" />
        </div>
        <div class="vx-col w-3/12">
          <vs-input label="Goods Name" v-model="currentProduct.denumireMarfa" class="w-full" />
        </div>
        <div class="vx-col w-1/12">
          <vs-input label="Quantity" v-model="currentProduct.cantitate" class="w-full" />
        </div>
        <div class="vx-col w-1/12">
          <div style="font-size: 85%">Unit of Measure</div>
          <v-select style="background-color: #ffffff" class="w-full mt-1" autocomplete :options="unitOptions"
            v-model="currentProduct.codUnitateMasura" />
        </div>
        <div class="vx-col w-1/12">
          <vs-input label="Net (kg)" v-model="currentProduct.greutateNeta" class="w-full" />
        </div>
        <div class="vx-col w-1/12">
          <vs-input label="Brut (kg)" v-model="currentProduct.greutateBruta" class="w-full" />
        </div>
        <div class="vx-col w-2/12">
          <vs-input label="Value (RON, without VAT)" v-model="currentProduct.valoareLeiFaraTva" class="w-full" />
        </div>
        <div class="vx-col w-2/12">
          <vs-button @click="addProduct" class="mt-5">Register Product</vs-button>
        </div>
      </div>
      <div class="vx-row mt-2">
      </div>

      <h6 class="mt-2 mb-2" v-if="etransport_products.length > 0"> Registered Products</h6>
      <vs-table :data="etransport_products" class="table-dark-inverted mb-base" style="color: #999;">
        <template slot="thead">
          <vs-th>REF</vs-th>
          <vs-th>Cod Tarifar</vs-th>
          <vs-th>Denumire Marfa</vs-th>
          <vs-th>Cantitate</vs-th>
          <vs-th>Greutate Neta</vs-th>
          <vs-th>Greutate Bruta</vs-th>
          <vs-th>Valoare Lei Fara TVA</vs-th>
          <vs-th>Action</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(product, index) in data" :key="index">
            <vs-td>{{ product.internalId }}</vs-td>
            <vs-td>{{ product.codTarifar }}</vs-td>
            <vs-td>{{ sanitizeDenumire(product.denumireMarfa) }}</vs-td>
            <vs-td>{{ product.cantitate }}{{ product.codUnitateMasura.label }}</vs-td>
            <vs-td>{{ product.greutateNeta }}kg</vs-td>
            <vs-td>{{ product.greutateBruta }}kg</vs-td>
            <vs-td>{{ product.valoareLeiFaraTva }}RON</vs-td>
            <vs-td>
              <span @click="deleteProduct(index)" style="color: red; cursor: pointer;">
                DELETE
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-button type="border" @click="popupWeight = true" class="mt-6">{{ weightStr }}</vs-button>

      <h3 class="mt-8">6. Transport Documents</h3>
      <div class="vx-row mt-2">
        <div class="vx-col w-1/4">
          <div style="font-size: 85%">Document Type</div>
          <v-select style="background-color: #ffffff" class="w-full mt-1" autocomplete
            :options="etransport_document_type" v-model="currentDocument.tipDocument" />
        </div>
        <div class="vx-col w-1/4">
          <p class="w-full mt-2">
          <div style="font-size: 85%">Document Date</div>
          <datepicker :inline="false" v-model="currentDocument.dataDocument"></datepicker>
          </p>
        </div>
        <div class="vx-col w-1/4"
          v-if="currentDocument.tipDocument.value === '20' || currentDocument.tipDocument.value === '30'">
          <vs-input label="Document Number" v-model="currentDocument.numarDocument" class="w-full" />
        </div>
        <div class="vx-col w-1/4" v-if="currentDocument.tipDocument.value === '10'">
          <vs-input label="Observations" v-model="currentDocument.observatii" class="w-full" />
        </div>
        <div class="vx-col w-1/4">
          <vs-button @click="addDocument" class="mt-6">Register Document</vs-button>
        </div>
      </div>

      <h6 class="mt-2 mb-2" v-if="etransport_documents.length > 0"> Registered Documents</h6>

      <vs-table :data="etransport_documents" class="table-dark-inverted mb-base" style="color: #999;">
        <template slot="thead">
          <vs-th>Type Document</vs-th>
          <vs-th>Date Document</vs-th>
          <vs-th>Number/Observations</vs-th>
          <vs-th>Action</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="(document, index) in data" :key="index">
            <vs-td>{{ document.tipDocument.label }}</vs-td>
            <vs-td>{{ formatDate(document.dataDocument) }}</vs-td>
            <vs-td>{{ document.numarDocument || document.observatii }}</vs-td>
            <vs-td>
              <span @click="deleteDocument(index)" style="color: red; cursor: pointer;">
                DELETE
              </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="vx-card p-6 mt-8">
      <h3>7. XML</h3>
      <div class="etx-checks">
        <div class="etx-checks-title">Checks before sending
          <span class="etx-count etx-error" v-if="issueCount('error')">{{ issueCount('error') }} problem{{ issueCount('error') === 1 ? '' : 's' }}</span>
          <span class="etx-count etx-warning" v-if="issueCount('warning')">{{ issueCount('warning') }} to check</span>
          <span class="etx-count etx-todo" v-if="todoCount()">{{ todoCount() }} to fill in</span>
        </div>
        <div v-if="!formIssues.length" class="etx-ok">Nothing suspicious detected.</div>
        <ul v-else class="etx-list">
          <li v-for="(issue, i) in formIssues" :key="i" :class="isTodo(issue) ? 'etx-todo' : 'etx-' + issue.level">
            <span class="etx-tag">{{ issue.section }}</span> {{ issue.text }}
          </li>
        </ul>
        <div class="etx-note">These checks are advice: only the ANAF has the final say, but a red line is almost always why an upload is refused.</div>
      </div>
      <vs-button icon-pack="feather" color="primary" @click="generatedXML">Generate</vs-button>
      <pre>{{ xmlvalue }}</pre>
    </div>
    <div class="w-full mt-4" v-if="xmlvalue">
      <vs-button icon-pack="feather" class="w-full" color="success" @click="confirmSendETransport">Send to
        SPV</vs-button>
    </div>

    <div class="vx-card p-6 mt-8" v-if="xmlvalue">
      <h3>8. RESULT SPV</h3>
      <pre>{{ result }}</pre>
      <a :href="generateLink(result)" target="_blank">CHECK STATUS</a>
    </div>
    <vs-popup class="holamundo" title="Weight" :active.sync="popupWeight">
      <vs-input label="Total Weight Bruta (kg)" v-model="totalWeight" class="w-full" />
      <vs-button icon-pack="feather" color="primary" @click="saveWeight" class="mt-4">Update</vs-button>
    </vs-popup>
  </div>

</template>

<script>
import axios from "@/axios.js";
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from 'vuejs-datepicker'
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moduleBankList from "@/store/bank/moduleDataList.js";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {

      idinvoiceautoselect: null,
      idtransportautoselect: null,
      result: {},
      weightStr: "Total Weight Bruta : 0 kg",
      popupWeight: false,
      totalWeight: 0,
      dataIdOperationExisting: {},
      dataIdTransportExisting: {},
      xmlvalue: null,
      xmlGeneratedFrom: null,
      commercialPartner_country: null,
      commercialPartner_name: null,
      commercialPartner_cif: null,
      dataETransportScope: null,
      dataStop: null,
      dataStart: null,
      currentProduct: {
        codTarifar: '4404',
        denumireMarfa: '',
        cantitate: '',
        codUnitateMasura: '',
        greutateNeta: '',
        greutateBruta: '',
        valoareLeiFaraTva: ''
      },
      etransport_products: [],
      unitOptions: [
        { label: "Pcs (H87)", value: "H87" },
        { label: "m3 (MTQ)", value: "MTQ" }
      ],
      etransport_document_type: [
        { label: "10. CMR", value: "10" },
        { label: "20. INVOICE", value: "20" },
        { label: "30. AVIZ", value: "30" },
      ],
      currentDocument: {
        tipDocument: '',
        dataDocument: '',
        numarDocument: '',
        observatii: ''
      },
      etransport_documents: [],
      dataDate: null,
      labelStart: 'Start',
      labelStop: 'Stop',
      dataStart: null,
      dateStop: null,
      dataETransportType: { value: null },
      dataETransporterCountry: {},
      etransport_truckplate: null,
      etransport_trailerplate1: null,
      etransport_trailerplate2: null,
      etransport_transporter_name: null,
      etransport_transporter_cif: null,
      etransport_start: [],
      etransport_stop: [],
      etransport_type: [
        { label: "10. Achizitie intracomunitara", value: "10" },
        { label: "20. Livrare intracomunitara", value: "20" },
        { label: "30. Transport pe teritoriul national", value: "30" },
        { label: "40. Import", value: "40" },
        { label: "50. Export", value: "50" },
        { label: "60. Tranzactie intracomunitara - Intrare pentru depozitare/formare nou transport", value: "60" },
        { label: "70. Tranzactie intracomunitara - Iesire dupa depozitare/formare nou transport", value: "70" },
      ],
      etransport_scope: [
      ],
      etransport_country: [
        { label: "RO. Romania", value: "RO" },
        { label: "BG. Bulgaria", value: "BG" },
        { label: "HU. Hungary", value: "HU" },
        { label: "BE. Belgium", value: "BE" },
        { label: "CZ. Czechia", value: "CZ" },
        { label: "DK. Denmark", value: "DK" },
        { label: "DE. Germany", value: "DE" },
        { label: "EE. Estonia", value: "EE" },
        { label: "IE. Ireland", value: "IE" },
        { label: "EL. Greece", value: "EL" },
        { label: "ES. Spain", value: "ES" },
        { label: "FR. France", value: "FR" },
        { label: "HR. Croatia", value: "HR" },
        { label: "IT. Italy", value: "IT" },
        { label: "CY. Cyprus", value: "CY" },
        { label: "LV. Latvia", value: "LV" },
        { label: "LT. Lithuania", value: "LT" },
        { label: "LU. Luxembourg", value: "LU" },
        { label: "MT. Malta", value: "MT" },
        { label: "NL. Netherlands", value: "NL" },
        { label: "AT. Austria", value: "AT" },
        { label: "PL. Poland", value: "PL" },
        { label: "PT. Portugal", value: "PT" },
        { label: "SI. Slovenia", value: "SI" },
        { label: "SK. Slovakia", value: "SK" },
        { label: "FI. Finland", value: "FI" },
        { label: "SE. Sweden", value: "SE" },
        { label: "IS. Iceland", value: "IS" },
        { label: "LI. Liechtenstein", value: "LI" },
        { label: "NO. Norway", value: "NO" },
        { label: "CH. Switzerland", value: "CH" },
        { label: "GB. United Kingdom", value: "GB" },
        { label: "BA. Bosnia and Herzegovina", value: "BA" },
        { label: "ME. Montenegro", value: "ME" },
        { label: "MK. North Macedonia", value: "MK" },
        { label: "RS. Serbia", value: "RS" },
        { label: "AL. Albania", value: "AL" },
        { label: "TR. Turkey", value: "TR" },
        { label: "UA. Ukraine", value: "UA" },
        { label: "MD. Moldova", value: "MD" },
        { label: "GE. Georgia", value: "GE" },
        { label: "AM. Armenia", value: "AM" },
        { label: "AZ. Azerbaijan", value: "AZ" },
        { label: "BY. Belarus", value: "BY" },
        { label: "RU. Russia", value: "RU" },
        { label: "ZA. Africa de Sud", value: "ZA" },
        { label: "CA. Canada", value: "CA" },
        { label: "CN. China", value: "CN" },
      ],
      etransport_pf: [
        { label: "1. Petea (HU)", value: "1" },
        { label: "2. Bors (HU)", value: "2" },
        { label: "3. Vărșand (HU)", value: "3" },
        { label: "4. Nădlac (HU)", value: "4" },
        { label: "5. Calafat (BG)", value: "5" },
        { label: "6. Bechet (BG)", value: "6" },
        { label: "7. Turnu Măgurele (BG)", value: "7" },
        { label: "8. Zimnicea (BG)", value: "8" },
        { label: "9. Giurgiu (BG)", value: "9" },
        { label: "10. Ostrov (BG)", value: "10" },
        { label: "11. Negru Vodă (BG)", value: "11" },
        { label: "12. Vama Veche (BG)", value: "12" },
        { label: "13. Calarasi (BG)", value: "13" },
        { label: "14. Corabia (BG)", value: "14" },
        { label: "15. Oltenița (BG)", value: "15" },
        { label: "16. Carei (HU)", value: "16" },
        { label: "17. Cenad (HU)", value: "17" },
        { label: "18. Episcopia Bihor (HU)", value: "18" },
        { label: "19. Salonta (HU)", value: "19" },
        { label: "20. Săcuieni (HU)", value: "20" },
        { label: "21. Turnu (HU)", value: "21" },
        { label: "22. Urziceni (HU)", value: "22" },
        { label: "23. Valea lui Mihai (HU)", value: "23" },
        { label: "24. Vladimirescu (HU)", value: "24" },
        { label: "25. Porțile de Fier 1 (RS)", value: "25" },
        { label: "26. Naidas (RS)", value: "26" },
        { label: "27. Stamora Moravița (RS)", value: "27" },
        { label: "28. Jimbolia (RS)", value: "28" },
        { label: "29. Halmeu (UA)", value: "29" },
        { label: "30. Stânca Costești (MD)", value: "30" },
        { label: "31. Sculeni (MD)", value: "31" },
        { label: "32. Albita (MD)", value: "32" },
        { label: "33. Oancea (MD)", value: "33" },
        { label: "34. Galati Giurgiulesti (MD)", value: "34" },
        { label: "35. Constanta Sud Agigea", value: "35" },
        { label: "36. Siret (UA)", value: "36" },
        { label: "37. Nadlac 2 - A1 (HU)", value: "37" },
        { label: "38. Bors 2 - A3 (HU)", value: "38" },
      ],
      etransport_birouVamal: [
        { label: "12801. BVI Alba Iulia (ROBV0300)", value: "12801" },
        { label: "22801. BVI Arad (ROTM0200)", value: "22801" },
        { label: "22901. BVF Arad Aeroport (ROTM0230)", value: "22901" },
        { label: "22902. BVF Zona Liberă Curtici (ROTM2300)", value: "22902" },
        { label: "32801. BVI Pitești (ROCR7000)", value: "32801" },
        { label: "42801. BVI Bacău (ROIS0600)", value: "42801" },
        { label: "42901. BVF Bacău Aeroport (ROIS0620)", value: "42901" },
        { label: "52801. BVI Oradea (ROCJ6570)", value: "52801" },
        { label: "52901. BVF Oradea Aeroport (ROCJ6580)", value: "52901" },
        { label: "62801. BVI Bistriţa-Năsăud (ROCJ0400)", value: "62801" },
        { label: "72801. BVI Botoşani (ROIS1600)", value: "72801" },
        { label: "72901. BVF Stanca Costeşti (ROIS1610)", value: "72901" },
        { label: "72902. BVF Rădăuţi Prut (ROIS1620)", value: "72902" },
        { label: "82801. BVI Braşov (ROBV0900)", value: "82801" },
        { label: "92901. BVF Zona Liberă Brăila (ROGL0710)", value: "92901" },
        { label: "92902. BVF Brăila (ROGL0700)", value: "92902" },
        { label: "102801. BVI Buzău (ROGL1500)", value: "102801" },
        { label: "112801. BVI Reșița (ROTM7600)", value: "112801" },
        { label: "112901. BVF Naidăș (ROTM6100)", value: "112901" },
        { label: "122801. BVI Cluj Napoca (ROCJ1800)", value: "122801" },
        { label: "122901. BVF Cluj Napoca Aero (ROCJ1810)", value: "122901" },
        { label: "132901. BVF Constanţa Sud Agigea (ROCT1900)", value: "132901" },
        { label: "132902. BVF Mihail Kogălniceanu (ROCT5100)", value: "132902" },
        { label: "132903. BVF Mangalia (ROCT5400)", value: "132903" },
        { label: "132904. BVF Constanţa Port (ROCT1970)", value: "132904" },
        { label: "142801. BVI Sfântu Gheorghe (ROBV7820)", value: "142801" },
        { label: "152801. BVI Târgoviște (ROBU8600)", value: "152801" },
        { label: "162801. BVI Craiova (ROCR2100)", value: "162801" },
        { label: "162901. BVF Craiova Aeroport (ROCR2110)", value: "162901" },
        { label: "162902. BVF Bechet (ROCR1720)", value: "162902" },
        { label: "162903. BVF Calafat (ROCR1700)", value: "162903" },
        { label: "172901. BVF Zona Liberă Galaţi (ROGL3810)", value: "172901" },
        { label: "172902. BVF Giurgiuleşti (ROGL3850)", value: "172902" },
        { label: "172903. BVF Oancea (ROGL3610)", value: "172903" },
        { label: "172904. BVF Galaţi (ROGL3800)", value: "172904" },
        { label: "182801. BVI Târgu Jiu (ROCR8810)", value: "182801" },
        { label: "192801. BVI Miercurea Ciuc (ROBV5600)", value: "192801" },
        { label: "202801. BVI Deva (ROTM8100)", value: "202801" },
        { label: "212801. BVI Slobozia (ROCT8220)", value: "212801" },
        { label: "222901. BVF Iaşi Aero (ROIS4660)", value: "222901" },
        { label: "222902. BVF Sculeni (ROIS4990)", value: "222902" },
        { label: "222903. BVF Iaşi (ROIS4650)", value: "222903" },
        { label: "232801. BVI Antrepozite/Ilfov (ROBU1200)", value: "232801" },
        { label: "232901. BVF Otopeni Călători (ROBU1030)", value: "232901" },
        { label: "242801. BVI Baia Mare (ROCJ0500)", value: "242801" },
        { label: "242901. BVF Aero Baia Mare (ROCJ0510)", value: "242901" },
        { label: "242902. BVF Sighet (ROCJ8000)", value: "242902" },
        { label: "252901. BVF Orşova (ROCR7280)", value: "252901" },
        { label: "252902. BVF Porţile De Fier I (ROCR7270)", value: "252902" },
        { label: "252903. BVF Porţile De Fier II (ROCR7200)", value: "252903" },
        { label: "252904. BVF Drobeta Turnu Severin (ROCR9000)", value: "252904" },
        { label: "262801. BVI Târgu Mureş (ROBV8800)", value: "262801" },
        { label: "262901. BVF Târgu Mureş Aeroport (ROBV8820)", value: "262901" },
        { label: "272801. BVI Piatra Neamţ (ROIS7400)", value: "272801" },
        { label: "282801. BVI Corabia (ROCR2000)", value: "282801" },
        { label: "282802. BVI Olt (ROCR8210)", value: "282802" },
        { label: "292801. BVI Ploiești (ROBU7100)", value: "292801" },
        { label: "302801. BVI Satu-Mare (ROCJ7810)", value: "302801" },
        { label: "302901. BVF Halmeu (ROCJ4310)", value: "302901" },
        { label: "302902. BVF Aeroport Satu Mare (ROCJ7830)", value: "302902" },
        { label: "312801. BVI Zalău (ROCJ9700)", value: "312801" },
        { label: "322801. BVI Sibiu (ROBV7900)", value: "322801" },
        { label: "322901. BVF Sibiu Aeroport (ROBV7910)", value: "322901" },
        { label: "332801. BVI Suceava (ROIS8230)", value: "332801" },
        { label: "332901. BVF Dorneşti (ROIS2700)", value: "332901" },
        { label: "332902. BVF Siret (ROIS8200)", value: "332902" },
        { label: "332903. BVF Suceava Aero (ROIS8250)", value: "332903" },
        { label: "332904. BVF Vicovu De Sus (ROIS9620)", value: "332904" },
        { label: "342801. BVI Alexandria (ROCR0310)", value: "342801" },
        { label: "342901. BVF Turnu Măgurele (ROCR9100)", value: "342901" },
        { label: "342902. BVF Zimnicea (ROCR5800)", value: "342902" },
        { label: "352802. BVI Timişoara Bază (ROTM8720)", value: "352802" },
        { label: "352901. BVF Jimbolia (ROTM5010)", value: "352901" },
        { label: "352902. BVF Moraviţa (ROTM5510)", value: "352902" },
        { label: "352903. BVF Timişoara Aeroport (ROTM8730)", value: "352903" },
        { label: "362901. BVF Sulina (ROCT8300)", value: "362901" },
        { label: "362902. BVF Aeroport Delta Dunării Tulcea (ROGL8910)", value: "362902" },
        { label: "362903. BVF Tulcea (ROGL8900)", value: "362903" },
        { label: "362904. BVF Isaccea (ROGL8920)", value: "362904" },
        { label: "372801. BVI Vaslui (ROIS9610)", value: "372801" },
        { label: "372901. BVF Fălciu (-)", value: "372901" },
        { label: "372902. BVF Albiţa (ROIS0100)", value: "372902" },
        { label: "382801. BVI Râmnicu Vâlcea (ROCR7700)", value: "382801" },
        { label: "392801. BVI Focșani (ROGL3600)", value: "392801" },
        { label: "402801. BVI Bucureşti Poştă (ROBU1380)", value: "402801" },
        { label: "402802. BVI Târguri și Expoziții (ROBU1400)", value: "402802" },
        { label: "402901. BVF Băneasa (ROBU1040)", value: "402901" },
        { label: "512801. BVI Călăraşi (ROCT1710)", value: "512801" },
        { label: "522801. BVI Giurgiu (ROBU3910)", value: "522801" },
        { label: "522901. BVF Zona Liberă Giurgiu (ROBU3980)", value: "522901" }
      ],
      /* UE-27. Hors de cette liste => Export (codTipOperatiune 50) donc birou vamal.
         EL et GR tous les deux : etransport_country utilise EL, places.country_code utilise GR. */
      eu_countries: ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'EL',
        'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'],
      default_birou_vamal: '202801', // BVI Deva (ROTM8100) - siège XYLO IMPACT, Hunedoara
      default_ptf: '37',            // Nadlac 2 - A1 (HU)
      default_locatie: '0',         // TEIU XYLO
    };
  },
  watch: {
  dataDate() {
    this.syncDocumentDates();
  },
  etransport_transporter_cif(newValue) {
    const cleanedValue = newValue.replace(/^ro/i, "");

    if (cleanedValue !== newValue) {
      this.etransport_transporter_cif = cleanedValue;
      this.$vs.notify({
        title: 'RO in CIF cannot exist',
        text: 'RO in CIF cannot exist',
        color: 'danger'
      });
    }
  },

  // Pour nettoyer les caractères spéciaux dans etransport_transporter_name
  etransport_transporter_name(newValue) {
    const cleanedName = newValue.replace(/[^a-zA-Z0-9\s]/g, ""); // Retire tous les caractères spéciaux

    if (cleanedName !== newValue) {
      this.etransport_transporter_name = cleanedName;
      this.$vs.notify({
        title: 'Special characters removed',
        text: 'Special characters are not allowed in transporter name',
        color: 'warning'
      });
    }
  },

  // Pour nettoyer les caractères spéciaux dans commercialPartner_name
  commercialPartner_name(newValue) {
    const cleanedName = newValue.replace(/[^a-zA-Z0-9\s]/g, ""); // Retire tous les caractères spéciaux

    if (cleanedName !== newValue) {
      this.commercialPartner_name = cleanedName;
      this.$vs.notify({
        title: 'Special characters removed',
        text: 'Special characters are not allowed in partner name',
        color: 'warning'
      });
    }
  }
},
  computed: {
    existingtransport() {
      return this.$store.state.BankList.transportlist;
    },
    existingoperation() {
      return this.$store.state.BankList.operationlist;
    },
    existingproduct() {
      return this.$store.state.BankList.productlist;
    },
    /* Tout ce qui finit dans le XML : sert à détecter un formulaire modifié APRÈS « Generate »
       (sinon c'est l'ancien XML qui part, et l'ANAF refuse une deuxième fois pour la même raison). */
    formSnapshot() {
      return JSON.stringify([
        this.dataETransportType && this.dataETransportType.value,
        this.dataETransportScope && this.dataETransportScope.value,
        this.dataDate,
        this.dataETransporterCountry, this.etransport_transporter_name, this.etransport_transporter_cif,
        this.etransport_truckplate, this.etransport_trailerplate1, this.etransport_trailerplate2,
        this.dataStart && this.dataStart.value, this.dataStop && this.dataStop.value,
        this.commercialPartner_country, this.commercialPartner_name, this.commercialPartner_cif,
        this.etransport_products, this.etransport_documents,
      ]);
    },
    xmlIsStale() {
      return !!this.xmlvalue && this.xmlGeneratedFrom !== this.formSnapshot;
    },
    /* Aides à la saisie : d'où viendra le refus de l'ANAF, AVANT l'envoi.
       level : error (refus quasi certain) | warning (suspect) | info.
       missing : champ simplement pas encore rempli (listé dans le panneau, pas sous le champ). */
    formIssues() {
      const issues = [];
      const add = (level, section, field, text, missing = false) => issues.push({ level, section, field, text, missing });
      const S2 = '2. Transport', S3 = '3. Route', S4 = '4. Partner', S5 = '5. Goods', S6 = '6. Documents';
      const type = this.dataETransportType && this.dataETransportType.value;

      /* 1. Operation */
      if (!type) add('error', '1. Operation', 'operation', 'Operation type is not selected.', true);
      if (!this.dataETransportScope || this.dataETransportScope.value == null) add('error', '1. Operation', 'operation', 'Operation scope is not selected.', true);

      /* 2. Transport : date */
      const date = this.dataDate ? moment(this.dataDate) : null;
      if (!date || !date.isValid()) add('error', S2, 'date', 'Transport date is not set.', true);
      else if (date.isBefore(moment().startOf('day'))) add('warning', S2, 'date', `Transport date ${date.format('DD/MM/YYYY')} is in the past. The ANAF normally refuses a transport date before today: use today or a later date (an invoice date is not the transport date).`);

      /* 2. Transport : transporteur */
      const country = this.dataETransporterCountry;
      if (!country || typeof country !== 'string') add('error', S2, 'transporter', 'Transporter country is not selected.', true);
      if (!String(this.etransport_transporter_name || '').trim()) add('error', S2, 'transporter', 'Transporter name is empty.', true);
      if (country === 'RO') {
        const cif = String(this.etransport_transporter_cif || '').trim();
        if (!cif) add('error', S2, 'transporter', 'A Romanian transporter needs its CIF (digits only, without "RO").');
        else if (!/^\d{2,10}$/.test(cif)) add('warning', S2, 'transporter', `Transporter CIF "${cif}" should be 2 to 10 digits, nothing else.`);
      }

      /* 2. Transport : plaques */
      const plates = [['Truck plate', this.etransport_truckplate], ['Trailer plate 1', this.etransport_trailerplate1], ['Trailer plate 2', this.etransport_trailerplate2]]
        .map(([label, v]) => ({ label, text: String(v || '').trim() }));
      const filled = plates.filter(x => x.text);
      const norm = t => t.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      if (!plates[0].text) add('error', S2, 'plates', 'Truck plate is empty.', true);
      for (let i = 0; i < filled.length; i++) {
        for (let j = i + 1; j < filled.length; j++) {
          if (norm(filled[i].text) === norm(filled[j].text)) {
            add('error', S2, 'plates', `${filled[i].label} and ${filled[j].label} are the same (${filled[i].text}). The truck and each trailer have their own plate: check for a copy/paste.`);
          }
        }
      }
      if (plates[2].text && !plates[1].text) add('warning', S2, 'plates', 'Trailer plate 2 is filled but Trailer plate 1 is empty: use Trailer plate 1 first.');
      filled.forEach(x => {
        const special = x.text.replace(/[A-Za-z0-9\s]/g, '');
        if (special) {
          add('warning', S2, 'plates', `${x.label} "${x.text}" contains "${[...new Set(special)].join(' ')}". The ANAF expects letters and digits only (spaces are removed for you). If this field holds several plates (like "VL 20 TFA - VL 20 TCR"), put the truck and each trailer in its own field.`);
        } else if (norm(x.text).length > 10) {
          add('warning', S2, 'plates', `${x.label} "${x.text}" is very long for one plate: it probably holds two plates. Put the truck and each trailer in its own field.`);
        }
      });

      /* 3. Route */
      if (!this.dataStart || this.dataStart.value == null) add('error', S3, 'route', 'Route start is not selected.', true);
      if (!this.dataStop || this.dataStop.value == null) add('error', S3, 'route', 'Route stop is not selected.', true);

      /* 4. Partenaire commercial */
      const pc = this.commercialPartner_country;
      if (!pc) add('error', S4, 'partner', 'Partner country is not selected.', true);
      if (!String(this.commercialPartner_name || '').trim()) add('error', S4, 'partner', 'Partner name is empty.', true);
      if (pc && type) {
        const nonEU = this.isExportCountry(pc);
        if (type === '30' && pc !== 'RO') add('warning', S4, 'partner', `Type 30 is a transport inside Romania, but the partner country is ${pc}.`);
        if (['10', '20', '60', '70'].includes(type)) {
          if (pc === 'RO') add('warning', S4, 'partner', 'This is an intra-EU operation but the partner country is RO. Is the country right?');
          else if (nonEU) add('warning', S4, 'partner', `Partner country ${pc} is outside the EU: should this be 40 Import or 50 Export instead?`);
        }
        if (['40', '50'].includes(type) && !nonEU) add('warning', S4, 'partner', `Import / Export needs a partner outside the EU, but ${pc} is in the EU: should this be an intra-EU type (10 / 20)?`);
      }
      if (pc === 'RO' && !String(this.commercialPartner_cif || '').trim()) add('warning', S4, 'partner', 'Romanian partner without CIF / CNP: the ANAF may refuse it.');

      /* 5. Marchandises */
      if (!this.etransport_products.length) add('error', S5, 'goods', 'No goods registered: fill the fields and click "Register Product".', true);
      const num = v => { const t = String(v == null ? '' : v).trim(); return t === '' ? NaN : Number(t); };
      let totalGross = 0;
      this.etransport_products.forEach((pr, idx) => {
        const ref = `Line ${idx + 1} (${(this.sanitizeDenumire(pr.denumireMarfa) || 'no name').slice(0, 30)})`;
        const tariff = String(pr.codTarifar == null ? '' : pr.codTarifar).trim();
        if (!/^\d{4,8}$/.test(tariff)) add('error', S5, 'goods', `${ref}: Cod Tarifar "${tariff}" must be 4 to 8 digits (for example 7217 or 72172030).`);
        const fields = [['Net weight', pr.greutateNeta, true], ['Gross weight', pr.greutateBruta, true], ['Quantity', pr.cantitate, false], ['Value', pr.valoareLeiFaraTva, false]];
        fields.forEach(([label, raw, isWeight]) => {
          const text = String(raw == null ? '' : raw).trim();
          const n = num(raw);
          if (text.includes(',')) add('error', S5, 'goods', `${ref}: ${label} "${text}" contains a comma. Type a plain number with a dot for decimals and no thousands separator.`);
          else if (!Number.isFinite(n)) add('error', S5, 'goods', `${ref}: ${label} "${text}" is not a number.`);
          else if (n < 0 || (n === 0 && label !== 'Value')) add('error', S5, 'goods', `${ref}: ${label} must be greater than 0.`);
          else if (isWeight && /^\d{1,3}\.\d{3}$/.test(text)) add('warning', S5, 'goods', `${ref}: ${label} "${text}" looks like a thousands separator (as on many invoices: 22.820 kg means 22 820 kg). If so, type ${text.replace('.', '')}.`);
        });
        const net = num(pr.greutateNeta), gross = num(pr.greutateBruta);
        if (Number.isFinite(net) && Number.isFinite(gross) && gross < net) add('error', S5, 'goods', `${ref}: gross weight (${gross} kg) is lower than net weight (${net} kg). The gross must be greater than or equal to the net.`);
        if (num(pr.valoareLeiFaraTva) === 0) add('warning', S5, 'goods', `${ref}: the value is 0 RON.`);
        if (Number.isFinite(gross)) totalGross += gross;
      });
      if (totalGross > 40000) add('warning', S5, 'goods', `Total gross weight is ${totalGross} kg: more than a truck can legally carry (40 000 kg). Check for an extra zero.`);
      else if (totalGross > 0 && totalGross < 100) add('warning', S5, 'goods', `Total gross weight is only ${totalGross} kg. Did you type tonnes instead of kg?`);

      /* 6. Documents */
      if (!this.etransport_documents.length) add('warning', S6, 'documents', 'No transport document registered (CMR / invoice / aviz).');
      this.etransport_documents.forEach(d => {
        const label = (d.tipDocument && d.tipDocument.label) || 'Document';
        const t = String(d.tipDocument && d.tipDocument.value);
        if ((t === '20' || t === '30') && !String(d.numarDocument || '').trim()) add('error', S6, 'documents', `${label}: the document number is missing.`);
        const dd = d.dataDocument ? moment(d.dataDocument) : null;
        if (!dd || !dd.isValid()) add('error', S6, 'documents', `${label}: the date is missing or invalid.`);
      });

      /* Liens ERP */
      const unlinked = [];
      if (!this.linkedTransportId()) unlinked.push('transport');
      if (!this.linkedInvoiceId()) unlinked.push('invoice');
      if (unlinked.length) add('info', 'ERP', 'link', `No ${unlinked.join(' / ')} selected in "Copy ... Data": the UIT will NOT be saved in the ERP (normal for a purchase or import that has no ERP document).`);

      /* XML périmé */
      if (this.xmlIsStale) add('error', '7. XML', 'xml', 'The form changed since the XML was generated. Click Generate again, otherwise the OLD XML is sent.');

      const rank = { error: 0, warning: 1, info: 2 };
      return issues.sort((a, b) => rank[a.level] - rank[b.level]);
    },
  },
  methods: {
    /* Aides affichées sous un champ (les champs simplement vides restent dans le panneau du bas). */
    issuesFor(field) {
      return this.formIssues.filter(i => i.field === field && !i.missing);
    },
    /* Un champ pas encore rempli n'est pas une « erreur » tant que le XML n'a pas été généré. */
    isTodo(issue) {
      return issue.missing && !this.xmlvalue;
    },
    issueCount(level) {
      return this.formIssues.filter(i => i.level === level && !this.isTodo(i)).length;
    },
    todoCount() {
      return this.formIssues.filter(i => this.isTodo(i)).length;
    },
    saveWeight() {
      let sumBrut = 0;
      let sumNet = 0;
      const totalWeight = parseFloat(this.totalWeight);

      if (Number.isFinite(totalWeight)) {
        this.etransport_products.forEach(element => {
          sumBrut += parseFloat(element.greutateBruta);
          sumNet += parseFloat(element.greutateNeta);
        });

        this.etransport_products.forEach(element => {
          const brut = (parseFloat(element.greutateBruta) / sumBrut * totalWeight).toFixed(0);
          element.greutateBruta = brut;
          element.greutateNeta = (brut * 0.99).toFixed(0); // Réduire de 1% le poids brut pour obtenir le net
        });

        this.weightStr = "Total Weight (Bruta) : " + totalWeight + " kg"
        this.popupWeight = false
      } else {
        alert("Weight must be a number");
      }
    },
    generateLink(result) {
      return `https://xylo.codesinn.com/api/anaf/etransport/xmlstatus/${result.index_incarcare}`;
    },
    copyOperationData() {
      this.etransport_documents = []
      this.etransport_products = []
      //alert(JSON.stringify(this.dataIdOperationExisting))
      /*"value":134426,"label":"Invoice RO2024_00346","country":"RO","company_name":"Pasca Moise","vat_number":null,"invoice_no":"RO2024_00346","aviz":null} */
      /* commercial partner */
      this.commercialPartner_country = this.dataIdOperationExisting.country
        || this.countryFromVat(this.dataIdOperationExisting.vat_number)
      if (!this.commercialPartner_country) {
        this.$vs.notify({
          title: 'Partner country unknown',
          text: 'No billing address country on this operation - set the country and the operation type manually',
          color: 'warning'
        });
      }
      /* Hors UE => Export : la fin de trajet doit être un birou vamal, pas un punct de frontieră */
      if (this.isExportCountry(this.commercialPartner_country)) {
        this.dataETransportType = this.etransport_type.find(option => option.value === '50');
        this.updateETransportScope();
        this.dataETransportScope = this.etransport_scope.find(option => option.value === '9999');
      }
      this.commercialPartner_name = this.dataIdOperationExisting.company_name
      this.commercialPartner_cif = null
      if (this.dataIdOperationExisting.vat_number) this.commercialPartner_cif = this.dataIdOperationExisting.vat_number.replace(/\D/g, '')
      /* documents : CMR, facture et aviz portent TOUS la date du transport (règle métier).
         `followsTransportDate` les fait suivre dataDate (cf. watcher) : choisir la facture avant
         la date, ou changer la date ensuite, ne laisse plus « Invalid date » dans le XML. */
      const transportDate = this.transportDateStr()
      let objDocument10 = {
        tipDocument: { value: 10, label: '10. CMR' },
        dataDocument: transportDate,
        followsTransportDate: true,
        observatii: 'CMR'
      }
      this.etransport_documents.push({ ...objDocument10 })
      let objDocument20 = {
        tipDocument: { value: 20, label: '20. INVOICE' },
        dataDocument: transportDate,
        followsTransportDate: true,
        numarDocument: this.dataIdOperationExisting.invoice_no
      }
      if (this.dataIdOperationExisting.invoice_no) this.etransport_documents.push({ ...objDocument20 })
      let objDocument30 = {
        tipDocument: { value: 30, label: '30. AVIZ' },
        dataDocument: transportDate,
        followsTransportDate: true,
        numarDocument: this.dataIdOperationExisting.aviz
      }
      if (this.dataIdOperationExisting.aviz) this.etransport_documents.push({ ...objDocument30 })
      this.totalWeight = 0
      this.$store.dispatch('BankList/getListOfProductFromOperation', this.dataIdOperationExisting.value)
        .then(response => {
          //alert(JSON.stringify(this.$store.state.BankList.productlist))
          this.$store.state.BankList.productlist.forEach(e => {
            if (e.weight && e.category !== "Services") {
              let objProd = {
                codTarifar: 4404,
                internalId: e.id,
                denumireMarfa: this.sanitizeDenumire(e.category_ro + ' ' + e.name),
                cantitate: e.quantity,
                codUnitateMasura: { value: e.uom.replace("m3", "MTQ").replace("Pcs", "H87"), label: e.uom.replace("m3", "m3 (MTQ)").replace("Pcs", "Pcs (H87)") },
                greutateNeta: e.weight,
                greutateBruta: parseFloat(e.weight * 1.01).toFixed(0),
                valoareLeiFaraTva: e.pricehtva
              }
              this.etransport_products.push({ ...objProd })
            }
            this.weightStr = "Total Weight (Bruta) : " + (parseFloat(this.totalWeight) + parseFloat(e.weight) * 1.01).toFixed(0) + " kg"
            this.totalWeight = (parseFloat(this.totalWeight) + parseFloat(e.weight) * 1.01).toFixed(0)
          });
          /*[{"category_ro":"Materie primă","category":"Raw material (Sumal)","name":"Raw material (Sumal) Wood waste","quantity":"2.2","uom":"m3","volume":"2.20","weight":"1760"}] */
        })
    },
    /* Date du transport en YYYY-MM-DD, ou null si absente / illisible (jamais « Invalid date »). */
    transportDateStr() {
      if (!this.dataDate) return null
      const m = moment(this.dataDate)
      return m.isValid() ? m.format("YYYY-MM-DD") : null
    },
    /* Re-date les documents créés automatiquement (CMR / facture / aviz) sur la date du transport. */
    syncDocumentDates() {
      const date = this.transportDateStr()
      this.etransport_documents.forEach(doc => {
        if (doc.followsTransportDate) doc.dataDocument = date
      })
    },
    copyTransportData() {
      //alert(JSON.stringify(this.dataIdTransportExisting))
      this.dataDate = this.dataIdTransportExisting.date
      this.etransport_transporter_name = this.dataIdTransportExisting.transporter
      this.dataETransporterCountry = this.dataIdTransportExisting.country_code
      this.etransport_truckplate = this.dataIdTransportExisting.truck_plate
      this.etransport_trailerplate1 = this.dataIdTransportExisting.trailer_plate
      const numbersOnly = String(this.dataIdTransportExisting.vat_number || '').replace(/\D/g, '')
      if (this.dataIdTransportExisting.country_code == 'RO') this.etransport_transporter_cif = numbersOnly
      else this.etransport_transporter_cif = null


      /*{"value":134280,"isactive":true,"date":"2024-07-04","transporter":"LKW WALTER Internationale Transportorganisation AG"
      ,"client":"J. Down Contracting Ltd,J. Down Contracting Ltd","vat_number":"ATU19208701","country_code":"AT","truck_plate":null,
      "trailer_plate":null,"label":"#134280 - 2024-07-04 LKW WALTER Internationale Transportorganisation AG"} */
    },
    sanitizeDenumire(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '')
        .replace(/â/g, 'a')
        .replace(/Â/g, 'A')
        .replace(/é/g, 'e')
        .replace(/É/g, 'E')
        .replace(/~/g, '')
        .replace(/³/g, '3')
        .substring(0, 200);
    },
    generatedXML() {
      if (this.dataETransportType.value == null) { this.$vs.notify({ title: 'Error', text: '1. Operation Type is mandatory', color: 'danger' }); return; }
      /* Les vides ('' ou l'objet {} d'origine) passaient ces gardes : Generate ne faisait alors rien
         (portée null => exception muette) ou écrivait « [object Object] » dans le XML. */
      if (!this.dataETransportScope || this.dataETransportScope.value == null) { this.$vs.notify({ title: 'Error', text: '1. Operation Scope is mandatory', color: 'danger' }); return; }
      if (!String(this.etransport_transporter_name || '').trim()) { this.$vs.notify({ title: 'Error', text: '2. Transporter Name is mandatory', color: 'danger' }); return; }
      if (this.dataDate == null) { this.$vs.notify({ title: 'Error', text: '2. Transport Date is mandatory', color: 'danger' }); return; }
      if (!this.dataETransporterCountry || typeof this.dataETransporterCountry !== 'string') { this.$vs.notify({ title: 'Error', text: '2. Transporter country is mandatory', color: 'danger' }); return; }
      if (!String(this.etransport_truckplate || '').trim()) { this.$vs.notify({ title: 'Error', text: '2. Truck Plate is mandatory', color: 'danger' }); return; }
      if (!this.dataStart || this.dataStart.value == null) { this.$vs.notify({ title: 'Error', text: '3. Route start is mandatory', color: 'danger' }); return; }
      if (!this.dataStop || this.dataStop.value == null) { this.$vs.notify({ title: 'Error', text: '3. Route stop is mandatory', color: 'danger' }); return; }
      if (this.commercialPartner_country == null) { this.$vs.notify({ title: 'Error', text: '4. Partner country is mandatory', color: 'danger' }); return; }
      if (this.commercialPartner_name == null) { this.$vs.notify({ title: 'Error', text: '4. Partner name is mandatory', color: 'danger' }); return; }
      if (this.etransport_products.length == 0) { this.$vs.notify({ title: 'Error', text: '5. Transported Goods are mandatory', color: 'danger' }); return; }
      const undatedDocument = this.etransport_documents.find(e => !e.dataDocument || !moment(e.dataDocument).isValid());
      if (undatedDocument) { this.$vs.notify({ title: 'Error', text: `6. Document "${undatedDocument.tipDocument.label}" has no valid date - set the Transport Date`, color: 'danger' }); return; }
      /* TRANSPORT */
      let transportInfo = '';
      transportInfo += `<dateTransport nrVehicul="${this.etransport_truckplate.replace(/\s+/g, '')}"`;
      if (this.etransport_trailerplate1) transportInfo += ` nrRemorca1="${this.etransport_trailerplate1.replace(/\s+/g, '')}"`;
      if (this.etransport_trailerplate2) transportInfo += ` nrRemorca2="${this.etransport_trailerplate2.replace(/\s+/g, '')}"`;
      transportInfo += ` codTaraOrgTransport="${this.dataETransporterCountry}"`;
      if (this.dataETransporterCountry === 'RO' && this.etransport_transporter_cif) transportInfo += ` codOrgTransport="${this.etransport_transporter_cif}"`;
      transportInfo += ` denumireOrgTransport="${this.etransport_transporter_name}" dataTransport="${moment(this.dataDate).format("YYYY-MM-DD")}" />`;

      /* ROUTE */
      let startInfo = '';
      if (parseInt(this.dataStart.value) == 0) {
        startInfo = `<locStartTraseuRutier>
        <locatie codJudet="20" denumireLocalitate="Teiu" denumireStrada="Strada Principala" numar="115A" alteInfo="XYLO IMPACT SRL, Comuna Lapugiu de Jos"/>
      </locStartTraseuRutier>`;
      } else if (parseInt(this.dataStart.value) >= 1 && parseInt(this.dataStart.value) <= 38) {
        startInfo = `<locStartTraseuRutier codPtf="${this.dataStart.value}"/>`;
      } else {
        startInfo = `<locStartTraseuRutier codBirouVamal="${this.dataStart.value}"/>`;
      }

      let stopInfo = '';
      if (parseInt(this.dataStop.value) == 0) {
        stopInfo = `<locFinalTraseuRutier>
        <locatie codJudet="20" denumireLocalitate="Teiu" denumireStrada="Strada Principala" numar="115A" alteInfo="XYLO IMPACT SRL, Comuna Lapugiu de Jos"/>
      </locFinalTraseuRutier>`;
      } else if (parseInt(this.dataStop.value) >= 1 && parseInt(this.dataStop.value) <= 38) {
        stopInfo = `<locFinalTraseuRutier codPtf="${this.dataStop.value}"/>`;
      } else {
        stopInfo = `<locFinalTraseuRutier codBirouVamal="${this.dataStop.value}"/>`;
      }
      let documenteTransportXML = '';
      this.etransport_documents.forEach(e => {
        documenteTransportXML += `<documenteTransport tipDocument="${e.tipDocument.value}" `;
        if (e.numarDocument) {
          documenteTransportXML += `numarDocument="${e.numarDocument}" `;
        }
        documenteTransportXML += `dataDocument="${moment(e.dataDocument).format("YYYY-MM-DD")}" `;
        if (e.observatii) {
          documenteTransportXML += `observatii="${e.observatii}" `;
        }
        documenteTransportXML += `/>
        `;
      });

      /* PARTNERS */
      let partnerInfo = '';
      partnerInfo += `<partenerComercial codTara="${this.commercialPartner_country}"`;
      partnerInfo += ` denumire="${this.commercialPartner_name}"`;
      if (this.commercialPartner_country === 'RO' && this.commercialPartner_cif) partnerInfo += ` cod="${this.commercialPartner_cif}"`;
      partnerInfo += `/>`;
      /* PRODUCTS */

      let bunuriTransportateXML = '';
      this.etransport_products.forEach(e => {
        bunuriTransportateXML += `<bunuriTransportate codScopOperatiune="${this.dataETransportScope.value}"
                            codTarifar="${e.codTarifar}"
                            denumireMarfa="${this.sanitizeDenumire(e.denumireMarfa)}"
                            cantitate="${e.cantitate}"
                            codUnitateMasura="${e.codUnitateMasura.value}"
                            greutateNeta="${e.greutateNeta}"
                            greutateBruta="${e.greutateBruta}"
                            valoareLeiFaraTva="${e.valoareLeiFaraTva}"/>`;
      });

      this.xmlvalue = `<eTransport xmlns="mfp:anaf:dgti:eTransport:declaratie:v2" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="mfp:anaf:dgti:eTransport:declaratie:v2
      file:/D:/formInteractive/_inLucru/_proiecte/eTransport/final/SchemaSimtic_model_2022_03_15.xsd" codDeclarant="33531190">
      <!-- 1. Operation + 5. Transported Goods -->
      <notificare codTipOperatiune="${this.dataETransportType.value}">
        ${bunuriTransportateXML}
        <!-- 4. Commercial Partner -->
        ${partnerInfo}
        <!-- 2. Transport -->
        ${transportInfo}
        <!-- 3. Route -->
        ${startInfo}
        ${stopInfo}
        <!-- 6. Transport Documents -->
        ${documenteTransportXML}
      </notificare>
</eTransport>`
      this.xmlGeneratedFrom = this.formSnapshot
      const problems = this.formIssues.filter(i => i.level === 'error')
      if (problems.length) {
        this.$vs.notify({
          title: `XML generated, but ${problems.length} problem${problems.length === 1 ? '' : 's'} found`,
          text: `See "Checks before sending" above: ${problems[0].text}`,
          color: 'warning',
          time: 10000
        })
      }
    },
    addProduct() {

      let sumBrut = 0;
      let sumNet = 0;

      const totalWeight = parseFloat(this.totalWeight);

      this.weightStr = "Total Weight (Bruta) : " + (parseFloat(this.totalWeight) + parseFloat(this.currentProduct.greutateBruta)) + " kg"
      this.totalWeight = (parseFloat(this.totalWeight) + parseFloat(this.currentProduct.greutateBruta))


      if (this.currentProduct.denumireMarfa && this.currentProduct.cantitate && this.currentProduct.codUnitateMasura && this.currentProduct.greutateNeta && this.currentProduct.greutateBruta && this.currentProduct.valoareLeiFaraTva) {
        this.etransport_products.push({ ...this.currentProduct });

        this.currentProduct.codTarifar = '';
        this.currentProduct.denumireMarfa = '';
        this.currentProduct.cantitate = '';
        this.currentProduct.codUnitateMasura = '';
        this.currentProduct.greutateNeta = '';
        this.currentProduct.greutateBruta = '';
        this.currentProduct.valoareLeiFaraTva = '';
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fill in all required fields',
          color: 'danger'
        });
      }
    },
    deleteProduct(index) {
      this.etransport_products.splice(index, 1);


      let sumBrut = 0;
      let sumNet = 0;
      let totalWeight = 0;

      this.etransport_products.forEach(element => {
        sumBrut += parseFloat(element.greutateBruta);
        sumNet += parseFloat(element.greutateNeta);
      })

      this.weightStr = "Total Weight (Bruta) : " + sumBrut + " kg"
      this.totalWeight = (parseFloat(sumBrut))


    },
    addDocument() {
      if (this.currentDocument.tipDocument && this.currentDocument.dataDocument) {
        /* tipDocument est un objet {label, value} : le comparer à '20' ne se déclenchait jamais,
           une facture / un aviz sans numéro entrait dans le XML et l'ANAF le refusait. */
        const docType = String(this.currentDocument.tipDocument.value);
        if (!['20', '30'].includes(docType) || String(this.currentDocument.numarDocument || '').trim()) {
          this.etransport_documents.push({ ...this.currentDocument });
          this.currentDocument.tipDocument = '';
          this.currentDocument.dataDocument = '';
          this.currentDocument.numarDocument = '';
          this.currentDocument.observatii = '';
        } else {
          this.$vs.notify({
            title: 'Error',
            text: 'Please provide the document number for an invoice / aviz',
            color: 'danger'
          });
        }
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fill in all required fields',
          color: 'danger'
        });
      }
    },
    deleteDocument(index) {
      this.etransport_documents.splice(index, 1);
    },
    /* Les deux sélections peuvent être vides ({} au départ, undefined si l'auto-remplissage n'a pas
       trouvé le transport / la facture dans la liste) : ne jamais lire `.value` dessus en direct. */
    linkedTransportId() {
      return (this.dataIdTransportExisting && this.dataIdTransportExisting.value) || null;
    },
    linkedInvoiceId() {
      return (this.dataIdOperationExisting && this.dataIdOperationExisting.value) || null;
    },
    confirmSendETransport() {
      this.activePromptETransport = false;
      /* Sans transport / facture liés, l'ANAF crée bien l'UIT mais l'ERP ne peut pas l'enregistrer. */
      const unlinked = [];
      if (!this.linkedTransportId()) unlinked.push('transport');
      if (!this.linkedInvoiceId()) unlinked.push('invoice');
      /* Les contrôles rouges du panneau « Checks » sont la cause la plus probable d'un refus. */
      const problems = this.formIssues.filter(i => i.level === 'error');
      let text = `You are about to SEND the eTransport to SPV`;
      if (unlinked.length) text += `. No ${unlinked.join(' / ')} selected in "Copy ... Data": the UIT will NOT be saved in the ERP.`;
      if (problems.length) text += ` ${problems.length} problem${problems.length === 1 ? '' : 's'} detected (see "Checks before sending"): ${problems.slice(0, 3).map(i => i.text).join(' / ')}${problems.length > 3 ? ' ...' : ''}`;
      this.$vs.dialog({
        type: "confirm",
        color: problems.length ? "danger" : (unlinked.length ? "warning" : "success"),
        title: "Confirm eTransport",
        text,
        accept: this.SendETransport,
        acceptText: "Confirm",
      });
    },
    SendETransport() {
      let obj = {
        idtransport: this.linkedTransportId(),
        idinvoice: this.linkedInvoiceId(),
        xmldata: this.xmlvalue,
        product: this.etransport_products,
        who: localStorage.getItem("login-username")
      };
      /* La notification de succès était émise avant la réponse : un refus de l'ANAF
         affichait quand même "successfully sent" et l'erreur ne partait qu'en console. */
      this.$store
        .dispatch("BankList/uploadETransportXML", obj)
        .then((response) => {
          this.result = response.data
          this.$vs.notify({
            color: "success",
            title: "eTransport Sent to SPV!",
            text: `UIT ${(response.data && (response.data.UIT || response.data.uit)) || 'received'}`,
          });
        }).catch((err) => {
          console.error(err);
          const data = err.response && err.response.data;
          this.$vs.notify({
            color: "danger",
            title: "eTransport REFUSED",
            text: (data && (data.message || data.error)) || err.message || 'Unknown error - see the browser console',
            time: 15000
          });
        });
    },
    loadPFStop() {
      this.labelStart = "Start (location)"
      this.labelStop = "Stop (border)"
      this.etransport_start = this.etransport_pf
    },
    loadPFStart() {
      this.labelStop = "Stop (location)"
      this.labelStart = "Start (border)"
      this.etransport_start = this.etransport_pf
    },
    formatDate(date) {
      if (!date || !moment(date).isValid()) return "-";
      return moment(date).format("YYYY-MM-DD");
    },
    /* Pays hors UE-27 => opération d'export/import avec formalités douanières */
    isExportCountry(cc) {
      if (!cc) return false;
      return !this.eu_countries.includes(String(cc).trim().toUpperCase());
    },
    /* Repli quand l'opération n'a pas d'adresse de facturation liée : ATU19208701 => AT */
    countryFromVat(vat) {
      if (!vat) return null;
      const prefix = String(vat).trim().toUpperCase().match(/^[A-Z]{2}/);
      return prefix ? prefix[0] : null;
    },
    /* Garde une sélection de trajet encore valide, sinon prend le défaut de la liste active :
       TEIU XYLO (0) > BVI Deva (202801) > Nadlac 2 (37). Évite de laisser affiché un code
       périmé - ex. Nadlac resté dans le champ "Stop (birou vamal)" après passage en Export. */
    pickRouteDefault(list, current) {
      if (!Array.isArray(list) || list.length === 0) return null;
      if (current && list.some(option => option.value === current.value)) return current;
      const fallbacks = [this.default_locatie, this.default_birou_vamal, this.default_ptf];
      for (const value of fallbacks) {
        const match = list.find(option => option.value === value);
        if (match) return match;
      }
      return null;
    },
    updateETransportScope() {
      this.etransport_stop = []
      this.etransport_start = []
      if (this.dataETransportType.value === '10') {
        this.labelStop = "Stop (location)"
        this.labelStart = "Start (border)"
        this.etransport_start = this.etransport_pf
        this.etransport_stop = [{ label: "TEIU XYLO", value: '0' }],
          this.etransport_scope = [
            { label: "101. Comercializare", value: "101" },
            { label: "201. Producție", value: "201" },
            { label: "301. Gratuități", value: "301" },
            { label: "401. Echipament comercial", value: "401" },
            { label: "501. Mijloace fixe", value: "501" },
            { label: "601. Consum propriu", value: "601" },
            { label: "703. Operațiuni de livrare cu instalare", value: "703" },
            { label: "801. Leasing financiar/operațional", value: "801" },
            { label: "802. Bunuri în garanție", value: "802" },
            { label: "901. Operațiuni scutite", value: "901" },
            { label: "1001. Investiție în curs", value: "1001" },
            { label: "1101. Donații, ajutoare", value: "1101" },
            { label: "9901. Altele", value: "9901" }
          ];
      } else if (this.dataETransportType.value === '20') {
        this.etransport_start = [{ label: "TEIU XYLO", value: '0' }],
          this.etransport_stop = this.etransport_pf
        this.etransport_scope = [
          { label: "101. Comercializare", value: "101" },
          { label: "301. Gratuități", value: "301" },
          { label: "703. Operațiuni de livrare cu instalare", value: "703" },
          { label: "801. Leasing financiar/operațional", value: "801" },
          { label: "802. Bunuri în garanție", value: "802" },
          { label: "9901. Altele", value: "9901" }
        ];
      } else if (this.dataETransportType.value === '30') {
        this.etransport_scope = [
          { label: "101. Comercializare", value: "101" },
          { label: "704. Transfer între gestiuni", value: "704" },
          { label: "705. Bunuri puse la dispoziția clientului", value: "705" },
          { label: "9901. Altele", value: "9901" }
        ];
      } else if (['40', '60', '12'].includes(this.dataETransportType.value)) {
        this.labelStop = "Stop (location)"
        this.labelStart = "Start (birou vamal)"
        this.etransport_start = this.etransport_birouVamal
        this.etransport_stop = [{ label: "TEIU XYLO", value: '0' }],
          this.etransport_scope = [
            { label: "9999. Același cu operațiunea", value: "9999" }
          ];
      } else if (['50', '70', '14', '22', '24'].includes(this.dataETransportType.value)) {
        this.labelStop = "Stop (birou vamal)"
        this.labelStart = "Start (location)"
        this.etransport_stop = this.etransport_birouVamal
        this.etransport_start = [{ label: "TEIU XYLO", value: '0' }],
          this.etransport_scope = [
            { label: "9999. Același cu operațiunea", value: "9999" }
          ];
      } else {
        this.etransport_scope = [];
      }
      this.dataStart = this.pickRouteDefault(this.etransport_start, this.dataStart)
      this.dataStop = this.pickRouteDefault(this.etransport_stop, this.dataStop)
    },
  },
  async created() {
    if (!moduleBankList.isRegistered) {
      this.$store.registerModule("BankList", moduleBankList);
      moduleBankList.isRegistered = true;
    }

    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule("operationList", moduleOperationList);
      moduleOperationList.isRegistered = true;
    }

    this.$store.dispatch('BankList/getListOfTransportNearToday')
      .then(response => { })
    this.$store.dispatch('BankList/getListOfOperationNearToday')
      .then(response => { })

    this.idinvoiceautoselect = this.$route.params.idinvoice
    this.idtransportautoselect = this.$route.params.idtransport
    if (this.idinvoiceautoselect && this.idtransportautoselect) {
      this.$vs.notify({
        title: 'AUTO INPUT',
        text: 'STARTING PLEASE WAIT!!!',
        color: 'success'
      });


      this.dataETransportType = this.etransport_type.find(option => option.value === '20');
      this.updateETransportScope();
      this.dataETransportScope = this.etransport_scope.find(option => option.value === '101');
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

      await sleep(500);
      this.$vs.notify({
        title: 'AUTO INPUT',
        text: 'Starting to fill in transport data...',
        color: 'success'
      });
      await sleep(1000);
      try {
        if (this.idtransportautoselect && Array.isArray(this.existingtransport)) {
          this.dataIdTransportExisting = this.existingtransport.find(
            option => option.value === Number(this.idtransportautoselect) // Conversion en nombre
          );
          if (!this.dataIdTransportExisting) throw new Error(`transport #${this.idtransportautoselect} not in the list`)
          this.copyTransportData()
        }

      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: 'AUTO INPUT failed (transport)',
          text: `${error.message} - the transport list only holds active transports dated today or later. Pick it manually.`,
          color: 'danger',
          time: 8000
        });
      }


      this.$vs.notify({
        title: 'AUTO INPUT',
        text: 'Starting to fill in invoice data...',
        color: 'success'
      });
      await sleep(1000);
      try {
        if (this.idinvoiceautoselect && Array.isArray(this.existingoperation)) {
          this.dataIdOperationExisting = this.existingoperation.find(
            option => option.value === Number(this.idinvoiceautoselect) // Conversion en nombre
          );
          if (!this.dataIdOperationExisting) throw new Error(`invoice #${this.idinvoiceautoselect} not in the list`)
          this.copyOperationData()
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: 'AUTO INPUT failed (invoice)',
          text: `${error.message} - the invoice list only holds the last 3 days. Operation type stays "20. Livrare intracomunitara": check it before generating the XML.`,
          color: 'danger',
          time: 8000
        });
      }
      await sleep(500);
      /* Les deux extrémités ont déjà été pré-remplies par updateETransportScope() en fonction
         du type d'opération (Export => birou vamal Deva, intracom. => punct de frontieră). */
      this.$vs.notify({
        title: 'AUTO INPUT',
        text: `Selecting ${this.labelStart} => ${this.dataStart ? this.dataStart.label : 'NOTHING'}`,
        color: this.dataStart ? 'success' : 'danger'
      });
      await sleep(1000);
      this.$vs.notify({
        title: 'AUTO INPUT',
        text: `Selecting ${this.labelStop} => ${this.dataStop ? this.dataStop.label : 'NOTHING'}`,
        color: this.dataStop ? 'success' : 'danger'
      });
      if (!this.dataStart || !this.dataStop) {
        await sleep(1000);
        this.$vs.notify({
          title: 'Route incomplete',
          text: 'Please select the route start/stop manually before generating the XML',
          color: 'danger'
        });
      }
    }
  }
};
</script>

<style scoped>
.etx-checks { margin: 8px 0 16px; padding: 10px 12px; border: 1px solid #e5e7eb; border-radius: 6px; background: #f9fafb; }
.etx-checks-title { font-weight: 600; margin-bottom: 6px; }
.etx-count { display: inline-block; margin-left: 8px; padding: 0 8px; border-radius: 10px; font-size: 0.75rem; font-weight: 600; color: #fff; }
.etx-count.etx-error { background: #ea5455; }
.etx-count.etx-warning { background: #ff9f43; }
.etx-count.etx-todo { background: #9ca3af; }
.etx-list { list-style: none; margin: 0; padding: 0; }
.etx-list li { margin: 3px 0; padding-left: 8px; border-left: 3px solid transparent; font-size: 0.85rem; }
.etx-list li.etx-error { border-left-color: #ea5455; color: #b91c1c; }
.etx-list li.etx-warning { border-left-color: #ff9f43; color: #b45309; }
.etx-list li.etx-info { border-left-color: #00cfe8; color: #0e7490; }
.etx-list li.etx-todo { border-left-color: #d1d5db; color: #6b7280; }
.etx-tag { display: inline-block; min-width: 96px; margin-right: 6px; font-size: 0.7rem; font-weight: 600; text-transform: uppercase; opacity: 0.75; }
.etx-ok { color: #16a34a; font-size: 0.85rem; }
.etx-note { margin-top: 6px; font-size: 0.72rem; color: #9ca3af; }
.etx-hint { margin-top: 4px; font-size: 0.8rem; }
.etx-hint.etx-error { color: #ea5455; }
.etx-hint.etx-warning { color: #d97706; }
.etx-hint.etx-info { color: #0e7490; }
</style>
